import * as React from 'react';
const Type = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-type", ...props },
    React.createElement("polyline", { points: "4 7 4 4 20 4 20 7" }),
    React.createElement("line", { x1: "9", y1: "20", x2: "15", y2: "20" }),
    React.createElement("line", { x1: "12", y1: "4", x2: "12", y2: "20" })));
export default Type;
//# sourceMappingURL=Type.js.map